import { useMemo } from "react";
import { buildFeed, whenText } from "../utils/feed";
import "./UniverseFeed.css";

/**
 * 우주의 이야기. 이 우주에서 무엇을 읽고 무엇을 남겼는지 최근 순으로 본다.
 *
 * '다른 행성' 탭의 첫 화면이다. 이웃 행성만이 아니라 내 기록도 함께 흐른다 —
 * 방금 담은 것이 이 줄에 보이지 않으면 제대로 남았는지 알 수가 없다.
 */
const LABEL = {
  done: "완독했어요",
  reading: "읽고 있어요",
  story: "남긴 이야기",
  quote: "옮긴 문장",
};

export default function UniverseFeed({ allBooks = [], users = [], uid, quotes = [], onBookClick, onUserClick, onStoryClick, onQuoteClick }) {
  const items = useMemo(
    () => buildFeed({ allBooks, users, uid, quotes }),
    [allBooks, users, uid, quotes]
  );

  if (!items.length) return null;

  return (
    <div className="uf">
      <div className="uf-list">
        {items.map((it) => {
          const b = it.book;
          const go = () => {
            if (it.type === "story" && onStoryClick && b) onStoryClick(b.id, it.memoId);
            else if (it.type === "quote" && onQuoteClick && b) onQuoteClick(b.id, it.quoteId);
            else if (b && onBookClick) onBookClick(b.id);
          };
          return (
            <article key={it.key} className="uf-card">
              <button className="uf-who" onClick={() => onUserClick && onUserClick(it.user.id)}>
                <span className="uf-av" aria-hidden="true">{it.user.avatar || "🪐"}</span>
                <span className="uf-name">{it.user.name}</span>
                <span className="uf-when">{whenText(it.at, it.exact)}</span>
              </button>

              <button className="uf-body" onClick={go}>
                <span className="uf-tags">
                  {/* 내 기록이면 그것부터 밝힌다. 이름만으로는 자기 것인지
                      한눈에 들어오지 않는다. */}
                  {it.isMe && <span className="uf-tag uf-tag-me">나</span>}
                  {/* 내 행성에도 있는 책이면 그걸 먼저 알린다 — 이 칸에서
                      가장 반가운 소식이고, 누를 이유가 되기도 한다.
                      내 카드에는 붙이지 않는다: 내 책이 내 책과 같다는 말은
                      뜻이 없다. */}
                  {it.mine && !it.isMe && (it.type === "done" || it.type === "reading") && (
                    <span className="uf-tag uf-tag-same">같은 책</span>
                  )}
                  <span className={`uf-tag uf-tag-${it.type}`}>{LABEL[it.type]}</span>
                </span>

                {b && (
                  <span className="uf-book">
                    {b.cover
                      ? <img className="uf-cv" src={b.cover} alt="" loading="lazy" />
                      : <span className="uf-cv uf-cv-none" aria-hidden="true">📖</span>}
                    <span className="uf-bt">
                      <b>『{b.title}』</b>
                      {b.author && <small>{b.author}</small>}
                    </span>
                  </span>
                )}

                {it.text && <span className="uf-text">“{it.text}”</span>}
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
}
